import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Validators, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { ShopApiService } from 'src/app/home/services/shop-api.service';
import { ResetPasswordRequest } from 'src/app/home/interfaces/auth.interface';
import { CanDeactivate } from 'src/app/home/can-deactivate/can-deactivate';
import { ShopService } from 'src/app/home/services/shop.service';
import { AuthAPIService } from 'src/app/home/services/auth-api.service';
import { switchMap } from 'rxjs';
import { CaptchaService } from 'src/app/home/services/captcha.service';
import * as Sentry from '@sentry/angular';

@Component({
  selector: 'app-password-reset-form',
  templateUrl: './password-reset-form.component.html',
  styleUrls: ['../forms.component.scss'],
  standalone: false,
})
export class ResetPasswordFormComponent extends CanDeactivate implements OnInit {
  resetPasswordForm: UntypedFormGroup;
  @Output() toggleFormsEmiter = new EventEmitter<string>();
  success = false;

  constructor(
    private fB: UntypedFormBuilder,
    protected shopApiService: ShopApiService,
    protected shopService: ShopService,
    private authApiService: AuthAPIService,
    private captchaService: CaptchaService
  ) {
    super(shopApiService, shopService);
  }

  ngOnInit() {
    this.resetPasswordForm = this.fB.group({
      email: this.fB.control('', [Validators.required, Validators.email]),
    });
  }

  getFormControl(name) {
    return this.resetPasswordForm.get(name);
  }

  onSubmit() {
    const resetPasswordRequest: ResetPasswordRequest = this.resetPasswordForm.value;
    this.captchaService
      .execute()
      .pipe(
        switchMap((h_captcha_response) => {
          return this.authApiService.resetPassword({ ...resetPasswordRequest, h_captcha_response });
        })
      )
      .subscribe(
        (response: any) => {
          if (response.status === 1) {
            this.success = true;
          } else if (response.status === 0) {
            this.getFormControl('email').setErrors({
              incorrect_email: true,
            });
          }
        },
        (error) => {
          Sentry.captureException(error.error || error, {
            tags: {
              feature: 'password-reset',
            },
          });
        }
      );
  }

  toggleForms(form) {
    this.toggleFormsEmiter.emit(form);
  }

  getForm(): UntypedFormGroup {
    return this.resetPasswordForm;
  }

  canCloseTab(): boolean {
    return !this.getForm().dirty;
  }
}
